import type { ApiOrganization } from "~/server/api/organizations/index.get";
import type { ApiOrganizationCreateRequest } from "~/server/api/organizations/index.post";
import type { ApiOrganizationUpdateRequest } from "~/server/api/organizations/[organizationId]/index.put";
import type { ApiOrganizationCloneRequest } from "~/server/api/organizations/[organizationId]/clone.post";

export function useApiOrganizations() {
  return useFetch<ApiOrganization[]>("/api/organizations");
}

export async function createOrganization(data: ApiOrganizationCreateRequest): Promise<ApiOrganization> {
  return $fetch<ApiOrganization>("/api/organizations", {
    method: "POST",
    body: data
  });
}

export async function renameOrganization(
  id: number,
  name: string
): Promise<ApiOrganization> {
  return $fetch<ApiOrganization>(`/api/organizations/${id}`, {
    method: "PUT",
    body: { name } as ApiOrganizationUpdateRequest
  });
}

export async function deleteOrganization(id: number): Promise<void> {
  await $fetch(`/api/organizations/${id}`, { method: "DELETE" });
}

export async function cloneOrganization(
  id: number,
  payload?: ApiOrganizationCloneRequest | null
): Promise<ApiOrganization> {
  return $fetch<ApiOrganization>(`/api/organizations/${id}/clone`, {
    method: "POST",
    body: payload ?? {},
  });
}
